<template>
    <div class="page-table tabStyle mainDiv" id="affix-container">
        <div class="card-base baslikBg animated fadeInUp">{{$t("src.views.apps.urun.duzenleme.baslikH1")}}</div>
        <el-row :gutter="10">
            <el-form status-icon :model="urunForm" :rules="rulesUrun" ref="urunForm"
                     class="demo-ruleForm">
                <el-col :lg="18" :md="18" :sm="24" :xs="24">
                    <el-tabs tab-position="left" class="language">
                        <el-tab-pane>
                            <span slot="label"><i class="flag-icon flag-icon-tr"></i></span>
                            <div class="card-base card-shadow--medium demo-box bg-white animated fadeInLeft">
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.urun.tanimlama.baslik")'
                                                      prop="baslik">:
                                            <div v-if="linkVisible" style="float: right; display: flex">
                                                <div v-if="!VisibleA">
                                                    <el-link target="_blank" :underline="false"
                                                             :href="this.path">
                                                        {{this.path}}{{this.urunForm.link}}
                                                    </el-link>
                                                </div>
                                                <el-button v-if="duzenleBtnVisible"
                                                           style="margin-left: 10px; margin-bottom: 5px"
                                                           v-on:click="VisibleA = true; duzenleBtnVisible=false"
                                                           size="mini">Düzenle
                                                </el-button>
                                                <span v-if="VisibleA">{{this.path}}</span>
                                                <el-input
                                                        v-if="VisibleA" v-model="urunForm.link"
                                                        v-on:change="linkChange = false;$store.commit('changeTabsClose', false)"
                                                        v-on:blur="linkTespitLink();VisibleA=false; duzenleBtnVisible=true"
                                                        style="width: 50%" size="mini"></el-input>
                                            </div>
                                            <el-input
                                                    v-model="urunForm.baslik"
                                                    v-on:change="linkTespit"
                                                    :placeholder='$t("src.views.apps.sayfa.tanimlama.baslikPlace")'></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item
                                                :label='$t("src.views.apps.urun.kategori.tanimlama.urunKodu")'
                                                prop="urunKodu">
                                            <el-input disabled v-model="urunForm.urunKodu"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.altBaslik")'
                                                      prop="altBaslik">:
                                            <el-input
                                                    v-model="urunForm.altBaslik"
                                                    :placeholder='$t("src.views.apps.sayfa.tanimlama.altBaslikPlace")'></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.icerik")'
                                                      prop="icerik">:
                                            <ckeditor :editor="editor"
                                                      :config="editorConfig"
                                                      v-model="urunForm.icerik"
                                                      @input="seoIcerikTespit"
                                                      @blur="seoIcerikTespit"></ckeditor>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </div>
                            <el-collapse style="margin-top: 10px" v-model="activeCollapse">
                                <el-collapse-item title="Resim Ayarları" name="4">
                                    <el-row>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                            <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.resim")'
                                                          prop="resim">:
                                                <el-upload
                                                        class="resimler"
                                                        action=""
                                                        list-type="picture-card"
                                                        multiple
                                                        :file-list="imageListMain"
                                                        :auto-upload="false"
                                                        accept=".jpg,.jpeg,.png"
                                                        :on-change="imageUpload"
                                                        :on-preview="firstImage"
                                                        :on-remove="imageRemove">
                                                    <i slot="default" class="el-icon-plus"></i>
                                                </el-upload>
                                                <el-button style="margin-top: 15px;width: 150px;" type="primary"
                                                           v-on:click="serverImageList"
                                                           @click="dialogImgServerVisible = true; " size="mini">
                                                    Sunucudan
                                                    Seç
                                                </el-button>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-collapse-item>
                                <el-collapse-item title="Ürün Kategori Bilgileri" name="5">
                                    <el-row>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                            <el-form-item
                                                    prop="kategoriList">
                                                <el-transfer
                                                        id="transfer1"
                                                        v-model="urunForm.kategoriList"
                                                        filterable
                                                        :titles="['Kategori Listesi', 'Seçilen Kategoriler']"
                                                        @left-check-change="kategoriLeftChange"
                                                        @right-check-change="kategoriRightChange"
                                                        :format="{
                                                                noChecked: '${total}',
                                                                hasChecked: '${checked}/${total}'}"
                                                        :data="kategoriListesi">
                                                </el-transfer>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-collapse-item>
                                <el-collapse-item title="Ürün Opsiyon Bilgileri" name="6">
                                    <el-row>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                            <el-form-item
                                                    prop="opsiyonList">
                                                <el-transfer
                                                        id="transfer2"
                                                        v-model="urunForm.opsiyonList"
                                                        filterable
                                                        :titles="['Opsiyon Listesi', 'Seçilen Opsiyonlar']"
                                                        :format="{
                                                                    noChecked: '${total}',
                                                                    hasChecked: '${checked}/${total}'}"
                                                        @change="opsiyonChange"
                                                        :data="opsiyonListesi">
                                                    <!--<el-button class="transfer-footer" slot="left-footer" type="primary"-->
                                                    <!--style="float: left; margin-top: 8px"-->

                                                    <!--@click="opsiyonDetayDialog = true" size="mini">Yeni-->
                                                    <!--Opsiyon-->
                                                    <!--</el-button>-->
                                                </el-transfer>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-collapse-item>
                                <el-collapse-item title="SEO Ayarları" name="7">
                                    <el-row>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                            <el-form-item
                                                    :label='$t("src.views.apps.sayfa.tanimlama.seoBaslik")'
                                                    prop="seoBaslik">:
                                                <el-input
                                                        v-model="urunForm.seoBaslik"
                                                        maxlength="60"
                                                        show-word-limit
                                                        :placeholder='$t("src.views.apps.sayfa.tanimlama.seoBaslikPlace")'></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                            <el-form-item
                                                    :label='$t("src.views.apps.sayfa.tanimlama.seoIcerik")'
                                                    prop="seoIcerik">:
                                                <el-input type="textarea"
                                                          maxlength="140"
                                                          v-on:focus="seoIcerikChange = false"
                                                          show-word-limit
                                                          v-model="urunForm.seoIcerik"></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-collapse-item>
                            </el-collapse>
                        </el-tab-pane>
                        <el-tab-pane>
                            <span slot="label"><i class="flag-icon flag-icon-gb"></i></span>
                            <div class="card-base card-shadow--medium demo-box bg-white animated fadeInLeft">
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item
                                                :label='$t("src.views.apps.sayfa.tanimlama.dil.en.baslik")'
                                                prop="dil.en.baslik">:
                                            <el-input
                                                    v-model="urunForm.dil.en.baslik"
                                                    v-on:change="urunForm.dil.en.seoBaslik = urunForm.dil.en.baslik.substring(0, 60)"
                                                    :placeholder='$t("src.views.apps.sayfa.tanimlama.baslikPlace")'></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item
                                                :label='$t("src.views.apps.sayfa.tanimlama.dil.en.altBaslik")'
                                                prop="dil.en.altBaslik">:
                                            <el-input
                                                    v-model="urunForm.dil.en.altBaslik"
                                                    :placeholder='$t("src.views.apps.sayfa.tanimlama.altBaslikPlace")'></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item
                                                :label='$t("src.views.apps.sayfa.tanimlama.dil.en.icerik")'
                                                prop="dil.en.icerik">:
                                            <ckeditor :editor="editor"
                                                      :config="editorConfig"
                                                      v-model="urunForm.dil.en.icerik"
                                                      @input="seoIcerikDilTespit"
                                                      @blur="seoIcerikDilTespit"></ckeditor>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </div>
                            <el-collapse style="margin-top: 10px" v-model="activeCollapse">
                                <el-collapse-item title="Resim Ayarları" name="4">
                                    <el-row>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                            <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.resim")'
                                                          prop="resim">:
                                                <el-upload
                                                        class="resimler"
                                                        action=""
                                                        list-type="picture-card"
                                                        multiple
                                                        :file-list="imageListMain"
                                                        :auto-upload="false"
                                                        accept=".jpg,.jpeg,.png"
                                                        :on-change="imageUpload"
                                                        :on-preview="firstImage"
                                                        :on-remove="imageRemove">
                                                    <i slot="default" class="el-icon-plus"></i>
                                                </el-upload>
                                                <el-button style="margin-top: 15px;width: 150px;" type="primary"
                                                           v-on:click="serverImageList"
                                                           @click="dialogImgServerVisible = true; " size="mini">
                                                    Sunucudan
                                                    Seç
                                                </el-button>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-collapse-item>
                                <el-collapse-item title="SEO Ayarları" name="6">
                                    <el-row>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                            <el-form-item
                                                    :label='$t("src.views.apps.sayfa.tanimlama.seoBaslik")'
                                                    prop="dil.en.seoBaslik">:
                                                <el-input
                                                        v-model="urunForm.dil.en.seoBaslik"
                                                        maxlength="60"
                                                        show-word-limit
                                                        :placeholder='$t("src.views.apps.sayfa.tanimlama.seoBaslikPlace")'></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                            <el-form-item
                                                    :label='$t("src.views.apps.sayfa.tanimlama.seoIcerik")'
                                                    prop="dil.en.seoIcerik">:
                                                <el-input type="textarea"
                                                          maxlength="140"
                                                          v-on:focus="seoIcerikIngChange = false"
                                                          show-word-limit
                                                          v-model="urunForm.dil.en.seoIcerik"></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-collapse-item>
                            </el-collapse>
                        </el-tab-pane>
                    </el-tabs>
                </el-col>
                <el-col :lg="6" :md="6" :sm="24" :xs="24">
                    <el-collapse class="yanForm animated fadeInUp delay-1s" v-model="activeCollapse">
                        <el-collapse-item name="1" :title='$t("src.views.apps.sayfa.tanimlama.durum")'>
                            <el-row>
                                <div>
                                    <el-button size="mini" class="onayBtn"
                                               v-on:click="urunGuncelleme('urunForm')"
                                               type="primary">
                                        {{$t('src.views.apps.sayfa.guncelleme.sayfaguncelle')}}
                                    </el-button>
                                </div>
                            </el-row>
                        </el-collapse-item>
                    </el-collapse>
                    <div v-for="(item,index) in secilenOpsiyonlar" :key="index">
                        <el-collapse class="yanForm animated fadeInUp delay-1s" v-model="activeCollapse">
                            <el-collapse v-model="collapseOps">
                                <el-row :gutter="10">
                                    <el-col :span="20">
                                        <el-collapse-item :title='item.label' :name="index" class="margin-top-10">
                                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p"
                                                    style="margin-top: 5px">
                                                <el-form-item :label='item.label'>:
                                                    <el-input v-if="item.konum === '1'" v-model="item.aciklama.tr"></el-input>
                                                    <ckeditor v-if="item.konum === '0'" :editor="editor"
                                                              :config="editorConfig"
                                                              v-model="item.aciklama.tr"></ckeditor>
                                                </el-form-item>
                                            </el-col>
                                            <!--<el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p"-->
                                                    <!--style="margin-top: 5px">-->
                                                <!--<el-form-item :label='item.label+" (İngilizce)"'>:-->
                                                    <!--<el-input-->
                                                            <!--v-model="item.aciklama.en"></el-input>-->
                                                <!--</el-form-item>-->
                                            <!--</el-col>-->
                                        </el-collapse-item>
                                    </el-col>
                                    <el-col :span="4">
                                        <el-button type="danger" v-on:click="removeSecilen(index)" class="margin-top-20"
                                                   size="mini" icon="mdi mdi-close"></el-button>
                                    </el-col>
                                </el-row>
                            </el-collapse>
                        </el-collapse>
                    </div>
                </el-col>
            </el-form>
            <el-dialog
                    title="Opsiyon Konumu"
                    :visible.sync="dialogKonum"
                    width="50%">
                <el-row>
                    <el-col :span="12">
                        <el-radio v-model="urunForm.opsiyonKonum" label="0" @change="changeKonum('0')">
                            <img src="../../../assets/images/13.png" alt="Alt" width="80%" height="80%">
                        </el-radio>
                    </el-col>
                    <el-col :span="12">
                        <el-radio v-model="urunForm.opsiyonKonum" label="1" @change="changeKonum('1')">
                            <img src="../../../assets/images/14.png" alt="Sağ" width="80%" height="80%">
                        </el-radio>
                    </el-col>
                </el-row>
            </el-dialog>
            <el-dialog
                    title='Sunucudan Fotoğraf Seç'
                    :visible.sync="dialogImgServerVisible"
                    width="60%"
                    center>
                <el-upload
                        action="#"
                        accept=".jpg,.jpeg,.png"
                        :on-change="serverImageUpload"
                        list-type="picture-card"
                        :file-list="imageListServer"
                        :auto-upload="false">
                    <i slot="default" class="el-icon-plus"></i>
                    <div slot="file" slot-scope="{file}">
                        <img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
                        <span class="el-upload-list__item-actions">
                            <span class="el-upload-list__item-delete"
                                  @click="imageUploadtoServer(file)">
                                  <i class="el-icon-plus"></i>
                            </span>
                        </span>
                    </div>
                </el-upload>
            </el-dialog>
            <el-dialog
                    title="Opsiyon İçerik"
                    :visible.sync="opsiyonDetayVisible"
                    width="50%">
                <el-form :model="opsiyonForm" ref="opsiyonForm">
                    <el-row class="margin-top-10">
                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                            <el-form-item :label='$t("src.views.apps.urun.tanimlama.opsiyonBaslik")'>:
                                <el-input
                                        v-model="opsiyonForm.opsiyonBaslik"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                            <el-form-item :label='$t("src.views.apps.urun.tanimlama.opsiyonBaslikEn")'>:
                                <el-input
                                        v-model="opsiyonForm.opsiyonBaslikEn"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                            <el-form-item prop="yapiskan">
                                <el-switch
                                        v-model="opsiyonForm.yapiskan"
                                        active-value="1"
                                        inactive-value="0"
                                        active-text="Sabitle"
                                        inactive-text="Sabitleme">
                                </el-switch>
                            </el-form-item>
                        </el-col>
                        <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                            <el-form-item :label='$t("src.views.apps.urun.tanimlama.opsiyonKonum")'
                                          prop="opsiyonKonum">:
                                <el-button type="primary" size="mini" @click="dialogKonum = true">
                                    Seç
                                </el-button>
                                &nbsp;
                                <img v-if="opsiyonForm.opsiyonKonum === '0'" style="float: right"
                                     src="../../../assets/images/13.png" width="20%" height="20%">
                                <img v-if="opsiyonForm.opsiyonKonum === '1'" style="float: right"
                                     src="../../../assets/images/14.png" width="20%" height="20%">
                            </el-form-item>
                        </el-col>
                        <el-button type="primary" size="mini"
                                   @click="opsiyonTanimla('urunForm')">Opsiyon Tanımlama
                        </el-button>
                        <el-button size="mini" @click="opsiyonDetayVisible = false">Vazgeç</el-button>
                    </el-row>
                </el-form>
            </el-dialog>
        </el-row>
    </div>
</template>

<script>
    import JQuery from 'jquery';
    import ClassicEditor from '../../../../node_modules/ckeditor5-build-classic';

    import urunService from '../../../WSProvider/UrunService'
    import seoService from '../../../WSProvider/SeoService'
    import controllerService from '../../../WSProvider/ControllerService'
    import notification from '../../../notification'

    let $ = JQuery;
    let base64 = require('base64_js');
    let userDataEstas = "";
    export default {
        name: "UrunDuzenle",
        components: {},
        mounted() {
            this.getKategoriListesi();
            this.getOpsiyonListesi();
            this.updateUrunKodu = this.$store.state.updateKodu;
            this.getUrunDetay(this.updateUrunKodu);
        },
        data() {
            return {
                path: urunService.path,
                dialogKonum: false,
                opsiyonDetayVisible: false,
                konumText: "Seç",
                limit: 0,
                updateUrunKodu: '',
                updateData: [],
                updateDataKat: [],
                updateDataOps: [],
                updateDataEN: [],
                checkedKategori: [],
                checkedOpsiyon: [],
                urunDetayKlon: [],
                oldOpsiyonList: [],
                imageListServer: [],
                fileListServer: [],
                dialogImgServerVisible: false,
                dialogDocServerVisible: false,
                seoIcerikChange: true,
                seoIcerikIngChange: true,
                VisibleA: false,
                linkChange: true,
                linkVisible: false,
                duzenleBtnVisible: true,
                imageListMain: [],
                fileListMain: [],
                kategoriListesi: [],
                opsiyonListesi: [],
                secilenOpsiyonlar: [],
                secilenlerKlon: [],
                secilenOpsiyonlarPost: [],
                editor: ClassicEditor,
                editorConfig: {
                    language: 'tr'
                },
                activeCollapse: ['1', '2', '3', '4', '5', '6', '7'],
                collapseOps: ['1'],
                visibleSil: false,
                checked: true,
                urunForm: {
                    baslik: "",
                    altBaslik: "",
                    icerik: "",
                    link: '',
                    urunKodu: '',
                    seoBaslik: '',
                    seoIcerik: '',
                    resim: [],
                    kategoriList: [],
                    opsiyonList: [],
                    durum: "1",
                    dil: {
                        en: {
                            baslik: '',
                            altBaslik: '',
                            icerik: '',
                            seoBaslik: '',
                            seoIcerik: ''
                        },
                    }
                },
                opsiyonForm: {
                    opsiyonBaslik: '',
                    opsiyonBaslikEn: '',
                    yapiskan: '0',
                    opsiyonKonum: '1',
                },
                opsiyonAciklamaForm: {
                    opsiyonBaslik: [],
                    opsiyonBaslikEn: [],
                },
                rulesUrun: {
                    baslik: [{
                        required: true,
                        message: " ",
                        trigger: 'change'
                    }],
                    ustKategori: [{
                        required: true,
                        message: " ",
                        trigger: 'blur'
                    }],
                    urunKodu: [{
                        required: true,
                        message: " ",
                        trigger: 'blur'
                    }],
                },
            }
        },
        methods: {
            linkTespitLink() {
                let self = this;
                if (this.urunForm.link) {
                    seoService.linkKontrol(self.urunForm.link.replace("'", "")).then((response) => {
                        if (response.status === 200) {
                            self.urunForm.link = response.data;
                        } else {
                            notification.Status(response.status, this)
                        }
                    })
                }
            },
            linkTespit() {
                let self = this;
                if (this.linkChange) {
                    seoService.linkKontrol(self.urunForm.baslik.replace("'", "")).then((response) => {
                        if (response.status === 200) {
                            if (self.urunForm.baslik) {
                                self.urunForm.seoBaslik = self.urunForm.baslik.substring(0, 60);
                                if (response.status === 200) {
                                    self.linkVisible = true;
                                    self.urunForm.link = response.data;
                                }
                            } else if (!self.urunForm.baslik) {
                                self.linkVisible = false;
                                self.urunForm.link = '';
                                self.urunForm.seoBaslik = '';
                            }
                        } else {
                            notification.Status(response.status, this)
                        }
                    })
                }
            },
            getKategoriListesi() {
                let self = this;
                urunService.kategoriList().then((response) => {
                    if (response.status === 200) {
                        response.data.forEach(function (e) {
                            let obj = self.kategoriListesi.find(data => data.key === e.urunKategoriKodu);
                            if (obj === undefined) {
                                self.kategoriListesi.push({
                                    key: e.urunKategoriKodu,
                                    label: e.baslik,
                                });
                            }
                        })
                    } else {
                        notification.Status(response.status, this)
                    }
                })
            },
            getOpsiyonListesi() {
                let self = this;
                urunService.opsiyonList().then((response) => {
                    if (response.status === 200) {
                        response.data.forEach(function (e) {
                            let obj = self.opsiyonListesi.find(data => data.key === e.uopsiyonKodu);
                            if (obj === undefined) {
                                self.opsiyonListesi.push({
                                    key: e.uopsiyonKodu,
                                    label: e.baslik,
                                });
                            }
                        })
                    } else {
                        notification.Status(response.status, this)
                    }
                })
            },
            getUrunDetay() {
                let self = this;
                urunService.urunDetay(this.updateUrunKodu).then((response) => {
                    if (response.status === 200) {
                        if (response.data['resim']) {
                            response.data['resim'].forEach(function (e) {
                                if (e) {
                                    self.imageListMain.push({
                                        name: e,
                                        url: urunService.imageUrlOrta + e
                                    });
                                }
                            });
                        }
                        if (response.data.kategori) {
                            response.data.kategori.forEach(function (e) {
                                self.urunForm.kategoriList.push(e.ukategoriKodu)
                            })
                        }
                        if (response.data.icerik) {
                            this.urunForm.icerik = htmlDecode(response.data.icerik);
                        }
                        if (response.data.link) {
                            this.urunForm.link = response.data.link;
                            this.linkVisible = true
                        }
                        this.urunForm.baslik = response.data.baslik;
                        this.urunForm.altBaslik = response.data.altBaslik;
                        this.urunForm.urunKodu = response.data.urunKodu;
                        this.urunForm.seoBaslik = response.data.seoBaslik;
                        this.urunForm.seoIcerik = response.data.seoIcerik;
                        this.urunDetayKlon = JSON.stringify(response.data);
                        if (response.data.opsiyon) {
                            this.oldOpsiyonList = response.data.opsiyon;
                            response.data.opsiyon.forEach(function (e) {
                                self.urunForm.opsiyonList.push(e.uopsiyonKodu);
                                self.secilenOpsiyonlar.push({
                                    opsiyonKodu: e.uopsiyonKodu,
                                    label: e.baslik,
                                    konum: e.konum,
                                    aciklama: {
                                        tr: htmlDecode(e.aciklama),
                                        // en: e.dil.en.aciklama
                                    }
                                });
                                self.secilenlerKlon = JSON.stringify(self.secilenOpsiyonlar);
                            })
                        } else {
                            self.urunForm.opsiyonList = [];
                            self.secilenOpsiyonlar = [];
                            self.secilenlerKlon = JSON.stringify(self.secilenOpsiyonlar);
                        }
                    } else {
                        notification.Status(response.status, this)
                    }
                })
            },
            kategoriLeftChange(value) {
                let self = this;
                value.forEach(function (e) {
                    self.urunForm.kategoriList.push(e);
                    var item = {
                        durum: 1,
                        kategoriKodu: e
                    };
                    self.updateDataKat.push(item);
                });
            },
            kategoriRightChange(value) {
                let self = this;
                value.forEach(function (e) {
                    let obj = self.urunForm.kategoriList.find(data => data === e);
                    self.urunForm.kategoriList.splice(self.urunForm.kategoriList.indexOf(obj), 1);
                    var item = {
                        durum: 0,
                        kategoriKodu: e
                    };
                    self.updateDataKat.push(item);
                })
            },
            opsiyonChange(value) {
                let self = this;
                this.secilenOpsiyonlar = [];
                for (var y = 0; y < value.length; y++) {
                    if (self.secilenlerKlon.length !== 0) {
                        let objK = JSON.parse(self.secilenlerKlon).find(data => data.opsiyonKodu === value[y]);
                        if (objK) {
                            this.secilenOpsiyonlar.push(objK);
                        } else if (objK === undefined) {
                            let obj = self.opsiyonListesi.find(data => data.key === value[y]);
                            self.secilenOpsiyonlar.push({
                                opsiyonKodu: value[y],
                                label: obj.label,
                                aciklama: {
                                    tr: '',
                                    en: '',
                                }
                            });
                        }
                    } else {
                        let obj = self.opsiyonListesi.find(data => data.key === value[y]);
                        self.secilenOpsiyonlar.push({
                            opsiyonKodu: value[y],
                            label: obj.label,
                            aciklama: {
                                tr: '',
                                en: '',
                            }
                        });
                    }

                }
            },
            removeSecilen(index) {
                this.secilenOpsiyonlar.splice(index, 1);
                this.urunForm.opsiyonList.splice(index, 1);

            },
            seoIcerikTespit() {
                if (this.seoIcerikChange) {
                    const myStr = strip_html_tags(this.urunForm.icerik);
                    this.urunForm.seoIcerik = myStr.substring(0, 140);
                }
            },
            seoIcerikDilTespit() {
                if (this.seoIcerikIngChange) {
                    const myStr = strip_html_tags(this.urunForm.dil.en.icerik);
                    this.urunForm.dil.en.seoIcerik = myStr.substring(0, 140);
                }
            },
            firstImage(item) {
                var index = this.imageListMain.indexOf(item);
                this.imageListMain.splice(index, 1);
                this.imageListMain.unshift(item);
                notification.Status('success', this, item.name + " ana resim olarak ayarlandı..");
            },
            serverImageUpload(file, fileList) {
                if (file.raw["type"] === 'image/jpeg' || file.raw["type"] === 'image/png') {
                    this.sumResimFonk(file, randomText(13) + '-' + file.name);
                } else {
                    fileList.pop();
                    notification.Status('warning', this, 'Yalnızca ".jpeg", ".jpg" ve ".png" uzantılı görsel seçiniz!!');
                }
            },
            serverImageList() {
                var dizi = [];
                controllerService.sunucuResim('urun').then((response) => {
                    if (response.status === 200) {
                        response.data.forEach(function (e) {
                            var item = {
                                name: e,
                                url: urunService.imageUrlKucuk + e
                            };
                            dizi.push(item);
                        });
                        this.imageListServer = dizi;
                    }
                })
            },
            imageUploadtoServer(file) {
                if (this.imageListMain.length === 0) {
                    var item = {
                        name: file.name,
                        url: file.url,
                    };
                    this.imageListMain.push(item);
                    updateList(this, 'resim', 1, file.name);
                    notification.Status('success', this, file.name + ' resmi eklendi.');
                } else {
                    let obj = this.imageListMain.find(data => data.name === file.name);
                    if (obj === undefined) {
                        item = {
                            name: file.name,
                            url: file.url,
                        };
                        this.imageListMain.push(item);
                        updateList(this, 'resim', 1, file.name);
                        notification.Status('success', this, file.name + ' resmi eklendi.');
                    } else {
                        notification.Status('warning', this, 'Bu resim zaten mevcut');
                    }
                }
            },
            imageRemove(file) {
                this.imageListMain.splice(this.imageListMain.indexOf(file), 1);
                updateList(this, 'resim', 0, file.name);
            },
            sumResimFonk(file, imgname) {
                const files = file.raw;
                if (files) {
                    const reader = new FileReader();
                    reader.onload = e => {
                        const data = e.target.result;
                        controllerService.resimYukle('urun', imgname, data).then((response) => {
                            if (response.status === 200) {
                            } else {
                                notification.Status(response.status, this)
                            }
                        });
                    };
                    reader.readAsDataURL(files);
                }
            },
            imageUpload(file, fileList) {
                fileList.pop();
                if (file.raw["type"] === 'image/jpeg' || file.raw["type"] === 'image/png') {
                    var tip = file.raw["type"].split("/")[1];
                    if (this.urunForm.baslik) {
                        var imgname = randomText(13) + '-' + this.urunForm.link + "." + tip;
                    } else {
                        imgname = randomText(13) + '-' + file.name;
                    }
                    if (this.imageListMain.length === 0) {
                        var item = {
                            name: imgname,
                            url: file.url,
                            id: file.raw.lastModified
                        };
                        this.imageListMain.push(item);
                        this.sumResimFonk(file, imgname);
                        updateList(this, 'resim', 1, imgname);
                    } else {
                        let obj = this.imageListMain.find(data => data.id === file.raw.lastModified);
                        if (obj === undefined) {
                            item = {
                                name: imgname,
                                url: file.url,
                                id: file.raw.lastModified
                            };
                            this.imageListMain.push(item);
                            this.sumResimFonk(file, imgname);
                            updateList(this, 'resim', 1, imgname);
                        } else {
                            notification.Status('warning', this, 'Bu resim zaten mevcut');
                        }
                    }
                } else {
                    fileList.pop();
                    notification.Status('warning', this, 'Yalnızca ".jpeg", ".jpg" ve ".png" uzantılı görsel seçiniz!!');
                }
            },

            urunGuncelleme(formName) {
                let self = this;
                var klonDizi = [];
                for (var key in JSON.parse(this.urunDetayKlon)) {
                    if (key !== 'resim' && key !== 'dil' && key !== 'belge' && key !== 'kategori' && key !== 'opsiyon') {
                        if (JSON.parse(this.urunDetayKlon)[key] !== this.urunForm[key]) {
                            if (self.urunForm[key]) {
                                var item = {
                                    type: key,
                                    value: self.urunForm[key]
                                };
                                self.updateData.push(item);
                            }
                        }
                    } else if (key === 'dil') {
                        for (var keyDil in JSON.parse(self.urunDetayKlon).dil.en) {
                            if (JSON.parse(self.urunDetayKlon).dil.en[keyDil] !== self.urunForm.dil.en[keyDil]) {
                                if (self.urunForm.dil.en[keyDil]) {
                                    var itemEn = {
                                        type: keyDil,
                                        value: self.urunForm.dil.en[keyDil]
                                    };
                                    self.updateDataEN.push(itemEn);
                                }
                            }
                        }
                        if (self.updateDataEN.length !== 0) {
                            self.updateData.push({
                                type: "dil",
                                value: {
                                    en: self.updateDataEN,
                                }
                            })
                        }
                    }
                }
                for (var i = 0; i < self.secilenOpsiyonlar.length; i++) {

                    let obj1 = self.oldOpsiyonList.find(data => data.uopsiyonKodu === self.secilenOpsiyonlar[i].opsiyonKodu);
                    if (obj1 === undefined) {
                        self.updateDataOps.push({
                            durum: 1,
                            opsiyonKodu: self.secilenOpsiyonlar[i].opsiyonKodu,
                            aciklama: {
                                tr: self.secilenOpsiyonlar[i].aciklama.tr,
                                en: self.secilenOpsiyonlar[i].aciklama.en,
                            }
                        });

                    }
                    if (self.secilenlerKlon.length !== 0) {
                        let obj2 = JSON.parse(self.secilenlerKlon).find(data => data.opsiyonKodu === self.secilenOpsiyonlar[i].opsiyonKodu);
                        klonDizi.push(obj2);
                        if (obj2) {
                            if (self.secilenOpsiyonlar[i].aciklama.tr !== klonDizi[i].aciklama.tr) {
                                self.updateDataOps.push({
                                    durum: 2,
                                    opsiyonKodu: self.secilenOpsiyonlar[i].opsiyonKodu,
                                    dil: "tr",
                                    aciklama: self.secilenOpsiyonlar[i].aciklama.tr
                                })
                            }
                            if (self.secilenOpsiyonlar[i].aciklama.en !== klonDizi[i].aciklama.en) {
                                self.updateDataOps.push({
                                    durum: 2,
                                    opsiyonKodu: self.secilenOpsiyonlar[i].opsiyonKodu,
                                    dil: "en",
                                    aciklama: self.secilenOpsiyonlar[i].aciklama.en
                                })
                            }
                        }
                    }

                }
                for (var j = 0; j < this.oldOpsiyonList.length; j++) {
                    let obj0 = self.secilenOpsiyonlar.find(data => data.opsiyonKodu === self.oldOpsiyonList[j].uopsiyonKodu);
                    if (obj0 === undefined) {
                        self.updateDataOps.push({
                            durum: 0,
                            opsiyonKodu: self.oldOpsiyonList[j].uopsiyonKodu,
                        })
                    }
                }
                var statusKat = false;
                var statusOps = false;
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if (self.updateDataKat.length !== 0) {
                            urunService.urunKategoriGuncelle(self.updateUrunKodu, self.updateDataKat).then((response) => {
                                if (response.status === 200) {
                                    statusKat = true;
                                    notification.Status('success', self, 'Kategori başarıyla guncellendi.');
                                    this.resetForm(formName);

                                } else {
                                    notification.Status(response.status, self);
                                }
                            })
                        } else {
                            statusKat = true;
                        }
                        if (self.updateDataOps.length !== 0) {
                            urunService.urunOpsiyonGuncelle(self.updateUrunKodu, self.updateDataOps).then((response) => {
                                if (response.status === 200) {
                                    statusOps = true;
                                    notification.Status('success', self, 'Opsiyon başarıyla guncellendi.');
                                    this.resetForm(formName);

                                } else {
                                    notification.Status(response.status, self);
                                }
                            })
                        } else {
                            statusOps = true;
                        }
                        if (self.updateData.length !== 0) {
                            urunService.urunGuncelle(self.updateUrunKodu, self.updateData).then((response) => {
                                if (response.status === 200) {
                                    if (statusKat && statusOps) {
                                        notification.Status('success', self, 'Ürün başarıyla guncellendi.');
                                        this.resetForm(formName);
                                    }
                                } else if (response.status === 230) {
                                    notification.Status('warning', self, 'Bu bilgiler ile kayıtlı bir Ürün zaten mevcut');
                                } else {
                                    notification.Status(response.status, self);
                                }
                            })
                        }


                    }
                })
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
                $('.el-upload-list__item-delete').click();
                this.visibleSil = false;
                this.imageListMain = [];
                this.fileListMain = [];
                this.urunForm.link = null;
                this.linkVisible = false;
                let tabs = this.$store.state.tabList;
                if (tabs.length === 1) {
                    $(".horizontal-nav.pos-top").removeClass("shadowBox");
                }
                var obj = tabs.find(data => data.name === "UrunDuzenle");
                if (obj !== undefined) {
                    tabs.forEach((tab, index) => {
                        if (tab.name === "UrunDuzenle") {
                            this.$store.state.tabList.splice(index, 1);
                            if (tabs[index]) {
                                this.$store.commit('changeActiveTabs', tabs[index].name);
                            } else {
                                this.$store.commit('changeActiveTabs', tabs[index - 1].name);
                            }
                        }
                    });
                }
            },
            changeKonum(konum) {
                this.dialogKonum = false;
                this.konumText = "Değiştir";
                switch (konum) {
                    case '0' :
                        notification.Status('success', this, 'Opsiyon konumu "Tab" olarak seçildi.');
                        break;
                    case '1' :
                        notification.Status('success', this, 'Opsiyon konumu "Sağ" olarak seçildi.');
                        break;
                }
            }
        }
    }

    function htmlDecode(input) {
        if(input){
            var e = document.createElement('div');
            e.innerHTML = input;
            return e.childNodes[0].nodeValue;
        }

    }
    function updateList(self, type, durum, name) {
        var item = {
            type: type,
            value: [{
                durum: durum,
                [type]: name
            }]
        };
        self.updateData.push(item);
    }

    function strip_html_tags(str) {
        str = str.replace(/&nbsp;/gi, '');
        if ((str === null) || (str === ''))
            return false;
        else
            str = str.toString();
        return str.replace(/<[^>]*>/g, '');
    }

    function randomText(length) {
        let today = new Date();
        let day = today.getDate();
        let mounth = (today.getMonth() + 1);
        let year = today.getFullYear();
        let bugun = year + '' + (mounth <= 9 ? '0' + mounth : mounth) + '' + (day <= 9 ? '0' + day : day);

        var text = "";
        var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

        for (var i = 0; i < length; i++)
            text += possible.charAt(Math.floor(Math.random() * possible.length));
        return bugun + "-" + text;
    }
</script>

<style lang="scss" scoped>
    @import '../../../assets/scss/_variables';

    #transfer1 {
        display: flex;
    }

    #transfer2 {
        display: flex;
        position: relative;
        left: 25px;
    }

    .aciklamaSpan {
        position: absolute;
        top: 25px;
    }

    .page-table {
        &.overflow {
            overflow: hidden;
        }

        .table-box {
            overflow: hidden;
        }
    }

    .el-form-item {
        font-weight: bold;
    }

</style>